let language = {
    ADDRESS_VIEWER_FORM_FIRST_NAME_LABEL: "First Name:",
    ADDRESS_VIEWER_FORM_LAST_NAME_LABEL: "Last Name:",
    ADDRESS_VIEWER_FORM_COUNTRY_REGION_LABEL: "Country/Region:",
    ADDRESS_VIEWER_FORM_STATE_PROVINCE_LABEL: "State/Province:",
    ADDRESS_VIEWER_FORM_CITY_TOWN_LABEL: "City/Town:",
    ADDRESS_VIEWER_FORM_EMAIL_LABEL: "Email:",
    ADDRESS_VIEWER_FORM_EMAIL_ERROR_TIP1: "Can't be empty!",
    ADDRESS_VIEWER_FORM_EMAIL_ERROR_TIP2: "Invalid email!",
    ADDRESS_VIEWER_FORM_LOCATION_LABEL: "Location Type:",
    ADDRESS_VIEWER_FORM_PHONE1_LABEL: "Phone1:",
    ADDRESS_VIEWER_FORM_PHONE2_LABEL: "Phone2:",
    ADDRESS_VIEWER_FORM_POSTCODE_LABEL: "Postal Code:",
    ADDRESS_VIEWER_FORM_POSTCODE_ERROR_TIP1: "Can't be empty!",
    ADDRESS_VIEWER_FORM_POSTCODE_ERROR_TIP2: "Invalid post code!",
    ADDRESS_VIEWER_FORM_ADDRESS1_LABEL: "Address1:",
    ADDRESS_VIEWER_FORM_ADDRESS2_LABEL: "Address2:",
    ADDRESS_VIEWER_FORM_ADDRESS_TAG_LABEL: "Address Tag:",
    ADDRESS_VIEWER_FORM_SET_AS_DEFAULT_CHECKBOX: "Set As Default",
};

export { language }